import { Flex, Typography } from "antd";
import { InfoCircleOutlined, ArrowUpOutlined } from "@ant-design/icons";

const { Paragraph } = Typography

const CountWidget = (props) => {
    const { title, count, percentage } = props

    return (
        <Flex className="count-box" justify="center" vertical>
                    <Flex style={{ marginBottom: "12px" }} align="center">
                        <Paragraph style={{ marginBottom: 0 }} className="text-h3 text-weight-400 text-color-secondary">
                            {title}
                        </Paragraph>
                    </Flex>
                    <Flex style={{ width: "100%" }} justify="space-between" align="center" >
                        <Paragraph style={{ marginBottom: 0 }} className="text-h1 text-color-primary text-weight-600 line-height-32">
                            {count}
                        </Paragraph>
                        <Flex gap={5} justify="flex-end">
                            <ArrowUpOutlined style={{ color: "#52C41A" }} className="text-h1" />
                            <Paragraph className="text-h1 text-weight-600 line-height-32"
                                style={{
                                    marginBottom: 0,
                                    color: "#52C41A",
                                }}
                            >
                                {percentage}%
                            </Paragraph>
                            <InfoCircleOutlined style={{ color: "#00000073" }} />
                        </Flex>
                    </Flex>
                </Flex>
    )
}

export default CountWidget